import React, { useEffect, useState } from 'react';
import { Alert, Box, Button, Container, MenuItem, TextField, Typography } from '@mui/material';
import AppHeader from '../AppHeader';
import { useCurrentSiteId } from '../../hooks/useCurrentSiteId';
import { programAPI, saveBlob } from '../../services/api';

export default function BusSheetPage() {
  const siteId = useCurrentSiteId();
  const [buses, setBuses] = useState([]);
  const [bus, setBus] = useState('all');
  const [week, setWeek] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    let cancelled = false;
    programAPI.busSheet().then((res) => {
      if (!cancelled) setBuses(res.data.buses || []);
    }).catch(() => {
      if (!cancelled) setError('The bus list did not load.');
    });
    return () => { cancelled = true; };
  }, [siteId]);

  const print = () => {
    setError('');
    programAPI.busSheetPdf({ bus, week }).then((res) => {
      saveBlob(res.data, 'bus-sheet.pdf');
    }).catch(() => setError('The bus sheet did not print.'));
  };

  return (
    <>
      <AppHeader backTo="/transportation/busing" rightContent={<Typography variant="subtitle1">Bus sheet</Typography>} />
      <Container sx={{ py: 2 }}>
        <Typography variant="body2" sx={{ mb: 2 }}>
          One page per bus, for the printer. The week starts on Monday. This does not send email or a text.
        </Typography>
        {error && <Alert severity="error" sx={{ mb: 2 }}>{error}</Alert>}
        <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', alignItems: 'center' }}>
          <TextField select size="small" label="Bus" value={bus} onChange={(e) => setBus(e.target.value)} sx={{ minWidth: 200 }}>
            <MenuItem value="all">All</MenuItem>
            {buses.map((item) => <MenuItem key={item.name} value={item.name}>{item.name}</MenuItem>)}
          </TextField>
          <TextField size="small" type="date" label="Week of" InputLabelProps={{ shrink: true }} value={week} onChange={(e) => setWeek(e.target.value)} />
          <Button variant="contained" onClick={print}>PDF</Button>
        </Box>
      </Container>
    </>
  );
}
